export default {
  name: 'Alert',
  props: {
    width: {
      type: Number,
      default: 10
    },
    height: {
      type: Number,
      default: 10
    },
    color: {
      type: String,
      default: 'white'
    }
  }
};